import React from "react";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import ProfileCard from "./ProfileCard";

/** Linked agencies first, then pending requests and invites. */
export function sortAgencyRows(rows) {
  return [...(rows || [])].sort((a, b) => Number(a.status !== "APPROVED") - Number(b.status !== "APPROVED"));
}

// rows come from the server, already limited to training centers where the user holds a role.
export default function AgenciesCard({ rows, onAcceptInvite }) {
  const sorted = sortAgencyRows(rows);
  return (
    <ProfileCard id="agencies" title="Agencies" subtitle="Linked agencies can see your training records and compliance status.">
      {sorted.length === 0 ? (
        <div className="pf-empty">You are not affiliated with any agency yet.</div>
      ) : (
        sorted.map((row) => {
          const pending = row.status === "PENDING";
          const invited = row.status === "INVITED";
          const detail = invited ? "Invited you to join" : pending ? "Awaiting coordinator approval" : row.category ? `Role: ${row.category}` : "Linked agency";
          return (
            <div className={`pf-lr${pending || invited ? " pending" : ""}`} key={row.membershipId} data-testid={`profile-agency-${row.agencyId}`}>
              <span className="ic"><BusinessOutlinedIcon sx={{ fontSize: 18 }} /></span>
              <div>
                <b>{row.agencyName}</b>
                <small>
                  <span data-testid={`profile-agency-center-${row.agencyId}`}>{row.tenantName}</span> · {detail}
                </small>
              </div>
              <div className="r">
                {invited ? (
                  <button
                    type="button"
                    className="pf-btn pf-btn-p"
                    data-testid={`accept-agency-invite-${row.agencyId}`}
                    onClick={() => onAcceptInvite?.(row.membershipId)}
                  >
                    Accept invite
                  </button>
                ) : (
                  <span className={`pf-tag ${pending ? "pe" : "ok"}`}>{pending ? "Pending" : "Linked"}</span>
                )}
              </div>
            </div>
          );
        })
      )}
      <p className="pf-note" style={{ padding: "8px 0 16px" }}>
        To change your primary agency or add a secondary department, contact your training coordinator.
      </p>
    </ProfileCard>
  );
}
